import React, { useCallback, useMemo } from 'react';
import { Box, Icon, Popover } from '@televet/kibble-ui';
import { Role, SurveyType } from 'shared/types/graphql';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths } from 'routes';
import useClinicUser from 'shared/hooks/useClinicUser';

interface ISidePanelSurveyPopoverProps {
  surveyType: SurveyType;
}

const SidePanelSurveyPopover = ({ surveyType }: ISidePanelSurveyPopoverProps): JSX.Element => {
  const history = useHistory();
  const { clinicUser } = useClinicUser();
  const isAdmin = useMemo(() => clinicUser?.vetInfo?.roles?.some((r) => r.role === Role.Admin), [clinicUser]);

  const goToSurveyPage = useCallback(() => {
    history.push(RouteBasePaths.Survey);
  }, [history]);

  return (
    <Popover
      {...(isAdmin && {
        footerProps: { submitText: `Go to ${surveyType}`, onSubmit: goToSurveyPage, hideCancelButton: true },
      })}
      trigger="hover"
      anchor={
        <Box>
          <Icon name="infoCircle" size="xs" />
        </Box>
      }
    >
      If survey is enabled, determines whether it will ever send to this client.
    </Popover>
  );
};

export default SidePanelSurveyPopover;
